export default __webpack_public_path__ + "static/media/adeni.a06d39f7.jpg";